<template id="example-modal">
  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg create-encounter-modal mt-0 mb-0" role="document">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div id="cover-spin" v-if="isrefreshpre"></div>
          <div class="pb-3 pr-5 pl-5 pt-3">
            <div class="row" style="max-width: 898px; margin: 0 auto">
              <div class="col-md-12 px-0">
                {{ getPdfUrl }} {{ getdatafromparent }}
                <ul class="print-export new-rule-border">


                  <li>
                    <a v-on:click="onPrintPrescription()">
                      <i class="material-icons print">print</i>
                    </a>
                  </li>
                  <li style="border-right: 1px solid #eeeeee" v-if="$route.name == 'staffdashboard'">
                    <a data-target="#Sendemailp" data-toggle="modal" v-on:click="showEmailPopup()">
                      <i class="material-icons">email</i>
                    </a>
                  </li>
                  <li class="mt-1">
                    <span style="margin-right: 10px">
                      <span v-if="printable_header">{{ $t('Hide') }}</span>
                      <span v-if="!printable_header">{{ $t('Show') }}</span>{{ $t('Header') }}
                    </span>
                    <label class="container customcheck pr-1">
                      <input type="checkbox" id="printableheader" v-model="printable_header"
                        v-on:click="storeprintableheader()">
                      <span class="checkmark"></span>
                    </label>
                  </li>
                </ul>
                <div class="close-sec-hold">
                  <button type="button" class="close pl-2" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div id="modallistViewvdPrescriptionDetailsPrint" :style="{ fontFamily: this.$t('fontfam') }" v-if="
                (prescriptionobj ||
                  prescriptionobj != null ||
                  prescriptionobj != undefined)
              ">
                {{ getsignaturepath }} {{ getDownloadUrl }}
                <HeaderWrapper :printable="printable_header">
                  <div class="clinic-logo-hold">
                    <img v-if="ClicnicUrllogo != '' && printable_header" :src="ClicnicUrllogo" height="85px"
                      width="Auto">
                  </div>
                  <table width="100%" cellspacing="0" cellpadding="0" border="0"
                    style="margin-top: 15px" v-if="printable_header">

                    <tr style="
                        padding: 0px 40px;
                        background-color: rgb(255, 255, 255);
                      ">
                      <!-- {{prescriptionobj.staffDetails}} -->
                      <td class="wrapper1" width="50%" valign="top" text-align="center" style="padding-bottom:10px;">
                        <table width="100%" cellspacing="0" cellpadding="0" border="0">

                          <tr>
                            <td valign="top" align="right" style="display: block; margin: 0">
                              <span align="right" style="color: #212529;
                                  font-size: 14px;font-weight: 500;line-height: 140%;">
                                <span id="label_doctorname" v-if="prescriptionobj.staffDetails && prescriptionobj.staffDetails.title &&
                                  prescriptionobj.staffDetails.first_name">
                                  {{ prescriptionobj.staffDetails.title }}
                                  {{ prescriptionobj.staffDetails.first_name }}
                                  {{ prescriptionobj.staffDetails.last_name == null ? ""
                                    :prescriptionobj.staffDetails.last_name }}
                                </span>
                              </span>
                              <span
                                style="color: #212529;font-size: 14px;font-weight: 500;line-height: 140%;">{{ qualification }}</span>
                              <span align="right"
                                style="color: #212529;max-width: 50% !important;   display: block;font-size: 14px;font-weight: 500;line-height: 140%;">
                                <span id="label_quilification"
                                  v-if="prescriptionobj && prescriptionobj.staffDetails && prescriptionobj.staffDetails.category_list">{{
                                  prescriptionobj.staffDetails.category }}</span>
                              </span>

                              <span align="right" style="
                                  color: #212529;
                                  
                                  font-size: 14px;
                                  font-weight: 500;
                                  line-height: 140%;
                                " v-if="location_tephonedetails">
                                <span>{{ location_tephonedetails }}</span>
                              </span>
                            <br v-if="location_tephonedetails">
                              <span align="right" style=" color: #212529; 
                                  font-size: 14px; font-weight: 500; line-height: 140%;"
                                v-if="prescriptionobj.businessappintmenturl && prescriptionobj.businessappintmenturl != 'null' && !IsVS">
                                <a style="color: rgb(33, 37, 41); text-decoration: none;" target="_blank"
                                  :href="'https://' + prescriptionobj.businessappintmenturl" title="Mini-site URL"
                                  ref="Mini-site URL">{{ prescriptionobj.businessappintmenturl.split('/')[0] }}</a>
                              </span>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </HeaderWrapper>


                <table cellspacing="0" cellpadding="0" width="100%">
                  <thead>
                    <tr>
                      <td>
                        <div :class="printable_header
                            ? 'page-header-space'
                            : 'page-header-nospace'
                          "></div>
                      </td>
                    </tr>
                  </thead>
                  <tbody style="border: 0">
                    <tr>
                      <td>
                        <div class="page">
                          <table width="100%" cellspacing="0" cellpadding="0" border="0"
                            style="border-bottom: solid 1px #ccc !important">
                            <tr>
                              <td style="border: 0 !important" class="wrapper1" width="70%" valign="top" align="left">
                                <!-- {{prescriptionobj.patientdetails}} -->
                                <table width="100%" cellspacing="0" cellpadding="0" border="0">
                                  <tr>
                                    <td valign="top" align="left" style="
                                        padding: 10px 0;
                                        border: 0 !important;
                                      " v-if="prescriptionobj.patientdetails">
                                      <span style="
                                          display: block;
                                          float: left;
                                          width: 100%;
                                        ">
                                        <span style="
                                            font-weight: 500;
                                            
                                            font-size: 14px;
                                            line-height: 170%;
                                            width: 136px;
                                            display: inline-block;
                                            float: left;
                                          " id="label_patientname">{{ $t('Patientname') }}</span>
                                        <span style="
                                            font-weight: 400;
                                            color: #333333;
                                            width: auto;
                                            
                                          " id="value_patientname" v-if="
                                            prescriptionobj.patientdetails &&
                                            prescriptionobj.patientdetails.name
                                          ">
                                          :
                                          {{
                                            prescriptionobj.patientdetails.name
                                          }}
                                        </span>
                                      </span>

                                      <span style="
                                          display: block;
                                          float: left;
                                          width: 100%;
                                        ">
                                        <span style="
                                            font-weight: 500;
                                            
                                            font-size: 14px;
                                            line-height: 170%;
                                            width: 136px;
                                            display: inline-block;
                                            float: left;
                                          " id="label_registrationno">{{ $t('RegistrationNo') }}</span>
                                        <span style="
                                            font-weight: 400;
                                            color: #333333;
                                            width: auto;
                                            
                                          " id="value_registrationno">
                                          :
                                          {{formatRegId(
                                            prescriptionobj.patientdetails
                                              .patient_RegId)
                                          }}
                                        </span>
                                      </span>

                                      <span style="
                                          display: block;
                                          float: left;
                                          width: 100%;
                                        ">
                                        <span style="
                                            font-weight: 500;
                                            
                                            font-size: 14px;
                                            line-height: 170%;
                                            width: 136px;
                                            display: inline-block;
                                            float: left;
                                          " id="label_agesex">{{ $t('AgeSex') }}</span>
                                        <span style="
                                            font-weight: 400;
                                            color: #333333;
                                            width: auto;
                                            
                                          " id="value_agesex">
                                          :
                                          <span v-if="ageCalculated">{{ ageCalculated }} /</span>
                                          <span class="c_name" style="text-transform: capitalize" v-if="
                                            prescriptionobj.patientdetails
                                              .gender
                                          ">
                                            {{
                                              prescriptionobj.patientdetails
                                                .gender
                                            }}
                                          </span>
                                        </span>
                                      </span>


                                    </td>
                                  </tr>
                                </table>
                              </td>

                            </tr>
                          </table>
                          <table width="100%" border="0" cellspacing="0" cellpadding="0" class="wrapper"
                            style="float: left; width: 100%">
                            <tr>
                              <td align="left" valign="top" bgcolor="#FFFFFF" style="padding: 10px 0 5px 0"
                                class="wrapper">
                                <span class="body-text" style="
                                    
                                    color: #212529;
                                    font-size: 14px;
                                    line-height: 140%;
                                    text-transform: capitalize;
                                  " v-if="prescriptionobj">
                                  <span id="label_date" style="font-weight: 500">{{ $t('Date') }}</span>
                                  {{ prescriptionobj.modalencounterdate }}
                                </span>
                              </td>
                            </tr>
                            <tr data-v-d4c013fa>
                              <td data-v-d4c013fa align="left" valign="top" bgcolor="#FFFFFF" class="wrapper">
                                <span data-v-d4c013fa style="
                                    font-size: 28px;
                                    color: rgb(0, 86, 224);
                                  ">
                                  R
                                  <span data-v-d4c013fa
                                    style="font-size: 22px; font-weight: 500;margin-left:-7px;">x</span>
                                </span>
                              </td>
                            </tr>
                          </table>
                          <table cellpadding="0" cellspacing="0" class="table-print" style="
                              border-bottom: 1px solid #666666;
                              background: #ffffff;
                              width: 100%;
                              table-layout: fixed;
                            ">
                            <tr>
                              <td>
                                <table class="listview-table">
                                  <tr>
                                    <th id="th1">{{ $t("MedicineName") }}</th>
                                  </tr>
                                  <tr v-for="item in prescriptionobj.modalresultPrescriptions" :key="item.itemId">

                                    <td>
                                      <div class="preview-drag-modal">
                                        <div class="preview-drag-block">

                                          <div class="drag-main-block">
                                            <div class="drag-block" style="padding-bottom: 10px;">
                                              <div class="top">
                                                <div>
                                                  <i v-if="item.groupType == 'Medicines'" class="fa fa-stethoscope"
                                                    aria-hidden="true"></i>
                                                  <i v-else class="fa fa-heart-o"></i>
                                                </div>
                                                <div class="main-content">
                                                  <h4 style="margin: 0;padding: 0 0 5;">
                                                    <strong>
                                                      {{ getItemName(item, "te") }}
                                                      <span v-if="selectedLanguage != 'te'">
                                                        ({{ getItemName(item, selectedLanguage) }})
                                                      </span>
                                                    </strong>
                                                  </h4>
                                                   <div class="description-te">
                                                   <p class="prescription-text">
                                                      {{ getLanguageDesc(item, "te") }}
                                                    </p>
                                                  </div>

                                                  <div v-if="selectedLanguage && selectedLanguage !== 'te'"
                                                    class="description-other-lang">
                                                    <p class="prescription-text">
                                                      {{ getLanguageDesc(item, selectedLanguage) }}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>

                                <table cellpadding="0" cellspacing="0" v-if="
                                  !prescriptionobj.modalresultPrescriptions
                                " style="
                                    border-bottom: 0px solid rgb(225, 225, 225);
                                    background: rgb(250, 250, 250);
                                    width: 100%;
                                    padding: 15px;
                                  ">
                                  <tbody>
                                    <tr>
                                      <td colspan="3" valign="top" bgcolor="#fafafa" align="left">
                                        <p class="no-data-found p-5">{{ $t('Noprescriptionshavebeensuggested.') }}</p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </table>

                          <div id="prescriptionFooterNote1" class="prescriptionFooterNotehold" v-if="
                            prescriptionFooterNote1 &&
                            prescriptionFooterNote1.ehr_note_value
                          " v-html="prescriptionFooterNote1.ehr_note_value"></div>
                          <table width="100%" style="border-bottom: 1px solid #d4d5d7" border="0" cellspacing="0"
                            cellpadding="0" align="center">
                            <tr v-if="Doctordetailsshow == true">
                              <td align="right" valign="top" bgcolor="#FFFFFF"
                                style="padding: 30px 0 15px 0; margin: 0">
                                <img v-if="fileUrl != ''" :src="fileUrl" height="120px" width="Auto">

                                <span style="
                                    width: 100%;
                                    text-align: right;
                                    display: block;
                                    padding: 10px 0;
                                  " span id="label_sign_doctorname" v-if="
                                    prescriptionobj &&
                                    prescriptionobj.staffDetails && tenantId != '05c7079f-d889-4a40-8fac-0ae75c445c15'
                                  ">
                                  {{ prescriptionobj.staffDetails.title }}
                                  {{ prescriptionobj.staffDetails.first_name }}
                                  {{ prescriptionobj.staffDetails.last_name }}
                                </span>
                                <table width="100%" v-if="tenantId == '05c7079f-d889-4a40-8fac-0ae75c445c15'">
                                  <tr>
                                    <td align="right">
                                      <p style="margin-bottom:5px;font-weight:500;">Dr. Swati Rajagopal, KMC #:61458</p>
                                      <p style="margin-bottom:5px;font-weight:500;"></p>
                                      <p style="margin-bottom:5px;font-weight:500;">Arista Health Clinic</p>
                                      <p style="margin-bottom:5px;font-weight:500;">Aster CMI Hospital</p>
                                    </td>
                                  </tr>
                                </table>

                                <!-- <span style="width:100%; text-align:right; display: block;" v-if="prescriptionobj && prescriptionobj.staffDetails && prescriptionobj.staffDetails.category && prescriptionobj.staffDetails.category && !prescriptionobj.footernote1">Consultant - {{prescriptionobj.staffDetails.category}}</span> -->
                                <table v-if="prescriptionobj.footernote1" width="100%" cellpadding="0" cellspacing="0">
                                  <tr>
                                    <td align="center" valign="top">
                                      <p v-html="prescriptionobj.footernote1" style="
                                          margin: 10px 0 0;
                                          font-size: 12px;
                                        "></p>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>



                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>
                        <!--place holder for the fixed-position footer-->
                        <div :class="printable_header
                            ? 'page-footer-space'
                            : 'page-footer-nospace'
                          "></div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div :class="printable_header ? 'page-footer' : 'no-footer'">
                  <table width="100%" v-if="printable_header">
                    <tr>
                      <td align="center" style="padding: 10px 0">
                        <span class="body-text" style="
                            
                            color: #212529;
                            font-size: 13px;
                            font-weight: 500;
                            font-style: normal;
                          "> {{ $t('Thisdocumentisdigitallysignedandhencenomanualsignatureisrequired') }}

                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <span style="font-size: 13px; color: #aaa">{{ $t('Poweredby') }}</span>
                        <a href="https://www.genamet.com/" target="_blank" style="text-decoration: none">
                          <span style="
                              font-size: 13px;
                              color: rgb(0, 86, 224);
                              text-decoration: none;
                            ">www.genamet.com</span>
                        </a>
                        <a href="#" style="margin-right: 10px">
                          <img style="padding-top: 10px"
                            src="https://s3.amazonaws.com/genamet-static-uploads-dev/9c42767e-1559-426b-8c70-b54299e091dd/images/powered-genamet.png">
                        </a>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- VIew sendEmail popup -->

    <!-- End master print popup-->
    <div v-if="showhideemailpopup">
      <div class="modal fade" id="Sendemailp" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true">
        <div class="modal-dialog grt-md" role="document" style="
            width: 570px;
            background: #fff;
            border-radius: 3px;
            -webkit-border-radius: 3px;
          ">
          <div class="modal-content" style="padding: 20px 50px">
            <div class="modal-header">
              <h5 style="margin: 0px auto">{{ $t('SendEmail') }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="top: 10px">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <ul class="list-select" style="margin-bottom: 0px">
                <li class="data-hold" v-for="item in emaillist" :key="item">
                  <span>{{ item }}</span>
                  <a @click.prevent="removeEmail(item)" href="#">X</a>
                </li>
                <li>
                  <input type="text" v-model="customemail" @keyup.enter="addemail(customemail)" class="form-control"
                    placeholder="Type in email address & press enter">
                </li>
              </ul>
              <div v-if="errorsemail" style="
                  color: rgba(243, 69, 58, 0.8);
                  font-size: 13px;
                  font-weight: 500;
                  display: block !important;
                ">{{ errorsemail }}</div>
            </div>
            <div class="modal-footer" v-if="emaillist && emaillist.length > 0" style="padding-top: 0px">
              <button type="button" class="primary-btn ripple pull-right" data-dismiss="modal" aria-label="Close"
                @click="senddetailsoveremail()">{{ $t('Send') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import rest_service from "@/api/rest_service";
import { mapActions, mapGetters, Store } from "vuex";
import Axios from "axios";
import moment from "moment";
const staff_sub_url = "/staff/getselectedprojection";
import commonhelper from "@/common/commonhelper";
import InvoiceReceiptApi from "../../api/InvoiceReceipt.js";
import i18n from "@/plugin/i18n";
import HeaderWrapper from "@/components/Headers/HeaderWrapper";

export default {
  mixins: [commonhelper],
  props: {
    prescriptionobj: {
      type: Object,
      default: () => ({ getprescription: [] })  // default object with empty array
    },
    selectedLanguage: {
      type: String,
      default: 'te'
    },

  },
  components: {
    HeaderWrapper
    // masterprint: () => import("@/components/Print/Masterprint.vue"),
  },
  data() {
    return {
      patientemail: "",
      prescriptionobject: {},
      showhideemailpopup: false,
      emaillist: [],
      patientmobile: "",
      customemail: "",
      errorsemail: null,
      qualification: "",
      showModal: false,
      //getstafflistbyid:[],
      getdownloadfileUrl: "",
      signatureFlag: "staffSign",
      fileUrl: "",
      //fileUrl: "https://upload.wikimedia.org/wikipedia/commons/5/56/Autograph_of_Benjamin_Franklin.svg",
      tenantId: "14a552c6-9bf9-4283-8388-fb30c272a114",
      patientdetails: [],
      isrefreshpre: true,
      foldername: "",
      printable_header: false,
      location_tephonedetails: null,
      ClicnicUrllogo: null,
      ageCalculated: null,
      qrcodedata: null,
      prescriptionFooterNote1: {},
      Doctordetailsshow: true,
      langselected: "en",
      IsVS: false,
    };
  },
  created() {
    //rest_service.getQRCodeData();
    this.changeLocale();
    this.emaillist = [];
    this.tenantId = localStorage.getItem("tenantid");
  },
  watch: {
    customemail: function (val, oldVal) {
      this.errorsemail = "";
    },
  },
  mounted() {
    let business_data = localStorage.getItem("tenantbusinesssetup");
    if (business_data) {
      var Jsonbusinessdata = JSON.parse(business_data);
      this.IsVS = !!Jsonbusinessdata.isVS;
    }
  },
  computed: {
    ...mapGetters([
      //"gett_businesssetup",
      "gett_pdfurl",
    ]),
    processItems() {
      return this.prescriptionobj.staffDetails.category_list
        .map((item) => item.category)
        .join(", ");
    },
    formattedDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = today.getFullYear();
      return `${day}/${month}/${year}`;
    },
    getsignaturepath: function () {
      var signaturefilename = "";
      if (this.prescriptionobj.staffDetails) {
        if (this.prescriptionobj.staffDetails.signature_pic_file_name != null) {
          signaturefilename =
            this.prescriptionobj.staffDetails.signature_pic_file_name;
          this.foldername =
            this.prescriptionobj.staffDetails.tenant_id +
            this.$store.state.helper.tenant_s3upload_Folders
              .signatureDownloadPath +
            signaturefilename;
          this.signatureFlag = "staffSign";
          if (localStorage.getItem("SignatureExpiryDate")) {
            var Expirydate = localStorage.getItem("SignatureExpiryDate");
            var today = new Date();
            Expirydate = new Date(Expirydate);
            Expirydate = Expirydate.toLocaleDateString();
            today = today.toLocaleDateString();
            if (Expirydate > today) {
              if (localStorage.getItem("SignatureUrl")) {
                this.fileUrl = this.getdownloadfileUrl =
                  localStorage.getItem("SignatureUrl");
                this.isrefreshpre = false;
              } else {
                this.getUrlFromS3Bucket(this.foldername);
              }
            } else {
              this.getUrlFromS3Bucket(this.foldername);
            }
          } else {
            this.getUrlFromS3Bucket(this.foldername);
          }
        } else {
          this.isrefreshpre = false;
          //this.fileUrl="";
          this.signatureFlag = "";
        }
      }
    },
    getDownloadUrl() {
      //this.fileUrl="";
      if (
        this.getdownloadfileUrl &&
        this.getdownloadfileUrl.length > 0 &&
        this.getdownloadfileUrl.indexOf(
          "documents-gen-ehr-dev.s3.amazonaws.com"
        )
      ) {
        if (
          this.signatureFlag == "staffSign" &&
          this.signatureFlag.length > 0
        ) {
          this.fileUrl = this.getdownloadfileUrl;
        }
      }
    },
    getPdfUrl() {
      if (this.gett_pdfurl && this.prescriptionobj.PdfDownload) {
        var win = window.open(this.gett_pdfurl, "_blank");
        if (win) {
          //Browser has allowed it to be opened
          win.focus();
          this.ispdfview = false;
        } else {
          //Browser has blocked it
          alert("Please allow popups for this website");
        }
        this.prescriptionobj.PdfDownload = false;
      }
    },
    getdatafromparent() {
      if (
        this.prescriptionobj &&
        this.prescriptionobj.provider_id &&
        this.prescriptionobj.Dashboardstaff == "Dashboardstaff" &&
        (!this.prescriptionobj.staffDetails ||
          !this.prescriptionobj.staffDetails.category_list ||
          this.prescriptionobj.staffDetails.unique_id !=
          this.prescriptionobj.provider_id)
      ) {
        this.getstaffbyid(this.prescriptionobj.provider_id);
      }
      if (
        this.prescriptionobj &&
        this.prescriptionobj.Doctordetailsshow == false
      ) {
        this.Doctordetailsshow = this.prescriptionobj.Doctordetailsshow;
      }

      this.setCategory();
      this.printable_header = this.$store.state.helper.printable_header;
      if (localStorage.getItem("AppLocList")) {
        var locationlist = JSON.parse(localStorage.getItem("AppLocList"));
        if (localStorage.slctdappfacltaddr) {
          var selectedAppFacility = JSON.parse(localStorage.slctdappfacltaddr);
          locationlist.forEach((x) => {
            if (x.unique_id === selectedAppFacility.unique_id) {
              this.location_tephonedetails = x.clinic_contact_numbers;
              //this.location_address= x.address;
            }
          });
        }
      }
      if (!this.location_tephonedetails) {
        this.location_tephonedetails =
          this.prescriptionobj.staffDetails &&
            this.prescriptionobj.staffDetails.mobile
            ? this.prescriptionobj.staffDetails.mobile
            : "";
      }
      if (
        this.prescriptionobj &&
        this.prescriptionobj.modalresultPrescriptions
      ) {
        this.prescriptionobj.modalresultPrescriptions.forEach((element) => {
          var datechecking = moment(element.start_date).format("DD-MM-YYYY");
          var currentdate = new Date();
          var tomarrowdate = new Date();
          tomarrowdate.setDate(tomarrowdate.getDate() + 1);
          currentdate = moment(currentdate).format("DD-MM-YYYY");
          tomarrowdate = moment(tomarrowdate).format("DD-MM-YYYY");
          if (currentdate == datechecking) {
            element.showstartdate =
              "Today" +
              " (" +
              moment(element.start_date).format("DD-MM-YYYY") +
              ")";
          } else if (tomarrowdate == datechecking) {
            element.showstartdate =
              "Tomorrow" +
              " (" +
              moment(element.start_date).format("DD-MM-YYYY") +
              ")";
          } else {
            element.showstartdate = moment(element.start_date).format(
              "DD-MM-YYYY"
            );
          }
          if (element.end_date) {
            element.showenddate = moment(element.end_date).format("DD-MM-YYYY");
          } else {
            var date = moment(element.showstartdate, "DD-MM-YYYY").add(
              parseInt(element.course_period - 1),
              "days"
            );
            element.showenddate = moment(date).format("DD-MM-YYYY");
          }
          if (this.OnlyNumeric(element.tables_count)) {
            element.tabletcountperday = element.direction_morning
              ? parseInt(element.tables_count)
              : 0;
            element.tabletcountperday =
              parseInt(element.tabletcountperday) +
              (element.direction_afternoon
                ? parseInt(element.tables_count)
                : 0);
            element.tabletcountperday =
              parseInt(element.tabletcountperday) +
              (element.direction_evening ? parseInt(element.tables_count) : 0);
            element.tabletcountperday =
              parseInt(element.tabletcountperday) +
              (element.direction_night ? parseInt(element.tables_count) : 0);
            element.tabletcountperday =
              parseInt(element.tabletcountperday) +
              (element.direction_sos ? parseInt(element.tables_count) : 0);

            element.tabletscalcutation = false;
          } else {
            element.tabletcountperday = element.tables_count;
            element.tabletscalcutation = true;
          }
        });
      }
      if (localStorage && localStorage.ClicnicUrllogo) {
        this.ClicnicUrllogo = localStorage.ClicnicUrllogo;
      } else {
        if (
          this.$store.state.helper.st_s3bucket_name &&
          this.$store.state.helper.tenant_id &&
          this.$store.state.helper.st_business_logo_folder &&
          this.$store.state.helper.clinicLogoFileName
        ) {
          if (!this.$store.state.helper.clinicLogoUrl) {
            var logoURl =
              process.env.VUE_APP_S3_BUCKET_PUBLIC_NAME +
              this.$store.state.helper.tenant_id +
              process.env.VUE_APP_BUSINESS_LOGO_FOLDER +
              this.$store.state.helper.clinicLogoFileName;
            this.ClicnicUrllogo = this.$store.state.helper.clinicLogoUrl =
              logoURl;
            if (!localStorage.ClicnicUrllogo) {
              localStorage.setItem("ClicnicUrllogo", logoURl);
            }
          } else {
            this.ClicnicUrllogo = this.$store.state.helper.clinicLogoUrl;
            if (!localStorage.ClicnicUrllogo) {
              localStorage.setItem("ClicnicUrllogo", this.ClicnicUrllogo);
            }
          }
        }
      }
      if (this.prescriptionobj.provider_id) {
        this.getstaffname(this.prescriptionobj.provider_id);
        this.getPrescriptionStaticContent(this.prescriptionobj.provider_id);
      }
    },
  },
  methods: {
    formatRegId(value) {
      if (!value) return "";

      return value.replace(/-(\d+)/, (match, digits) => {
        return "-" + digits.padStart(6, "0");
      });
    },
    getItemName(item, lang) {
      if (!item || !item.languages) return '';
      const langEntry = item.languages.find(l => l.languageCode === lang);
      return langEntry ? langEntry.name : item.itemNameInEnglishOrFallback || '';
    },

    getLanguageDesc(item, lang) {
      if (!item || !item.languages) return '';
      const langEntry = item.languages.find(l => l.languageCode === lang);
      return langEntry ? langEntry.description : '';
    },
    changeLocale() {
      if (localStorage.getItem("is_language") == "true") {
        if (localStorage.getItem("Language") != "null") {
          var lang = JSON.parse(localStorage.getItem("Language"));
          i18n.locale = lang.languageCode;
        } else {
          i18n.locale = this.langselected;
        }
      } else {
        i18n.locale = this.langselected;
      }
    },
    getappointment(appointmentid) {
      var self = this;

      InvoiceReceiptApi.getappointment(appointmentid).then(
        (appointmentdetails) => {

          if (appointmentdetails.data) {
            self.patientemail =
              appointmentdetails.data.result.patient_details.email;
            if (self.patientemail) {
              self.emaillist.push(self.patientemail.toLowerCase());
            }
          }
        }
      );
    },

    showEmailPopup() {
      this.emaillist = [];
      this.getappointment(this.$parent.appointmentdetails.unique_id);
      if (this.emaillist != null) {
        if (this.emaillist.length > 1) {
          while (this.emaillist.length > 1) {
            //     // Remove elements from array
            this.emaillist.pop();
          }
        }
      }
      //   if (
      //             this.prescriptionobj.patientdetails.email &&
      //             this.validateEmail(this.prescriptionobj.patientdetails.email)
      //           ) {
      //             this.emaillist.push(this.prescriptionobj.patientdetails.email.toLowerCase());
      //             if(this.emaillist!=null){
      //             if(this.emaillist.length>1){
      //                 while (this.emaillist.length>1) {

      //     // Remove elements from array
      //     this.emaillist.pop();}
      // }
      //             }
      //  }
      this.showhideemailpopup = true;
    },

    senddetailsoveremail() {
      // this.showmasterprintpopup("email");
      this.onEmailData();
      this.showhideemailpopup = false;
      //this.resetEmailparams();
    },

    addemail(val) {
      if (this.validateEmail(val.toLowerCase())) {
        if (this.emaillist.indexOf(val.toLowerCase()) > -1) {
          this.errorsemail = "This email id is already added";
        } else {
          this.emaillist.push(val.toLowerCase().trim());
          this.customemail = "";
        }
      }
    },
    validateEmail(val) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (val && val.length > 0) {
        if (!re.test(val.toLowerCase())) {
          this.errorsemail = "Please provide a valid email address";
          return false;
        } else {
          this.errorsemail = null;
          return true;
        }
      }
    },
    removeEmail(val) {
      this.emaillist = this.emaillist.filter((e) => e !== val.toLowerCase());
    },
    resetEmailparams() {
      this.showhideemailpopup = false;
      this.emaillist = [];
      this.customemail = "";
    },
    getstaffname(staff_id) {

      this.getpatientdetails(this.prescriptionobj.patientdetails.unique_id);
      let self = this;
      var staff_fullname = "";
      var masterdata = {
        id: staff_id,
        projectionitems: "first_name,educationalQualificationsObjectArray",
      };
      rest_service
        .get("/staff/getselectedprojection", localStorage.tenantid, masterdata)
        .then((respo) => {
          if (respo.data && respo.data.result) {
            self.staff_data = respo.data.result;
            this.qualification = "";

            if (
              Array.isArray(self.staff_data.educationalQualificationsObjectArray) &&
              self.staff_data.educationalQualificationsObjectArray.length > 0
            ) {
              for (
                var i = 0;
                i < self.staff_data.educationalQualificationsObjectArray.length;
                i++
              ) {
                self.qualification +=
                  self.staff_data.educationalQualificationsObjectArray[
                    i
                  ].educationalQualifications;
                if (
                  i <
                  self.staff_data.educationalQualificationsObjectArray.length -
                  1
                ) {
                  self.qualification += ",";
                } else {
                  self.qualification = self.qualification;
                }
              }
            }
            if (self.staff_data.first_name && self.staff_data.last_name) {
              self.vitals_updated_doctor =
                self.staff_data.first_name + self.staff_data.last_name;
            } else {
              self.vitals_updated_doctor = self.staff_data.first_name;
            }
          } else {
            staff_fullname = "";
          }
          // return staff_fullname;
        });

      return staff_fullname;
    },
    ...mapActions(["ac_export_to_pdf", "ac_getbusinesssetup"]),
    OnlyNumeric(data) {
      var re = /^[0-9]*$/;
      var re2 = re.test(data);
      if (re2) return true;
      else return false;
    },
    calcAge(dateString) {
      var birthday = +new Date(dateString);
      return ~~((Date.now() - birthday) / 31557600000);
    },
    prespription_exporttoPDF() {
      this.prescriptionobj.PdfDownload = true;
      var content = document.getElementById(
        "modallistViewPrescriptionDetailsPrintvs"
      ).innerHTML;
      content = content.split('"').join("'");
      content = content.replace("//", "/\\/");
      content = content.replace(/(\r\n\t|\n|\r\t)/gm, "");
      this.ac_export_to_pdf(content);
    },
    storeprintableheader() {
      this.$store.state.helper.printable_header =
        document.getElementById("printableheader").checked;
    },
    onEmailData() {
      if (document.getElementById("modallistViewPrescriptionDetailsPrintvs")) {

        var self = this;
        let doctorname = "";
        // if(this.businessandotherdetails && this.businessandotherdetails.staffDetails && this.businessandotherdetails.staffDetails.first_name){
        //  doctorname = (this.businessandotherdetails.staffDetails.title?this.businessandotherdetails.staffDetails.title+" ":"")+(this.businessandotherdetails.staffDetails.first_name) +(this.businessandotherdetails.staffDetails.last_name?" "+this.businessandotherdetails.staffDetails.last_name:"");
        // }
        var style = "";
        if (self.tenantId == "44acd54f-5f3b-4567-a1a0-ca8e25d8ddc9") {
          style =
            ".page-header .clinic-logo-hold { top: 5px;left: 20px;position:absolute;}";
        }

        var content1 =
          "<html><head><title></title><style>" +
          self.$t("fonts") +
          style +
          "table.listview-table {font-family: arial, sans-serif;font-size: 14px;border-collapse: collapse;width: 100%;}table.listview-table th {border-top: 1px solid #666666;border-bottom: 1px solid #666666;text-align: left;padding: 3px 15px;}table.listview-table td {border: 0;text-align: left;padding: 5px;}table.listview-table tr:nth-child(even) {background-color: #fafafa;}.page-header,.page-header-space{height:20px}.page-header-space{margin-top:30px}.page-header-nospace{height:10px}.page-footer,.page-footer-nospace,.page-footer{width:100%;border-top:1px solid #d4d5d7}.page-header{height:200px;width:100%;border-bottom:1px solid #000}@page{size:A4;margin:.5in}@media print{thead{display:table-header-group}tfoot{display:table-footer-group}button{display:none}body{margin:0}}</style></head><body>" +
          document.getElementById("modallistViewPrescriptionDetailsPrintvs")
            .innerHTML +
          "</body></html>";

        var data = { data: content1, prefix: "empty" };
        var config = {
          method: "post",
          url: process.env.VUE_APP_HTML_TO_PDF_CLINICAL_NOTES_API,
          headers: {
            "Content-Type": "application/json",
            x_tenant_id: localStorage.tenantid,
          },
          data: data,
        };
        self.$parent.loadstatusmessage("An email is on the way", false);
        Axios(config)
          .then(function (response) {
            console.clear();
            console.log(JSON.stringify(response.data));
            self.sendNotification(response.data);
            self.$parent.showhideemailpopup = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    sendNotification(urldata) {

      var mobile1 =
        this.prescriptionobj.patientdetails.country_code +
        this.prescriptionobj.patientdetails.mobile;
      var appid = this.$parent.appointmentdetails.unique_id;
      let data = {
        url: urldata.url,
        emailids: this.emaillist,
        mobile: mobile1,
        appid: appid,
      };
      var self = this;
      var role_unique_id =
        JSON.parse(localStorage.loggedInUserInfo).role &&
          JSON.parse(localStorage.loggedInUserInfo).role.unique_id
          ? JSON.parse(localStorage.loggedInUserInfo).role.unique_id
          : "";
      var suburl = "/notification";
      let axiosconfig = {
        method: "post",
        url: rest_service.baseURL + suburl + "/secnn",
        headers: {
          x_tenant_id: localStorage.tenantid,
          role_unique_id: role_unique_id,
          loggedin_user_unique_id: JSON.parse(localStorage.loggedInUserInfo)
            .unique_id,
          route_entity_name: suburl,
          Authorization: localStorage.accesstoken,
        },
        data: data,
      };
      Axios(axiosconfig)
        .then((response) => {
          if (response && response.data && response.data.result) {
            self.$parent.loadstatusmessage(
              "Email has been sent successfully",
              false
            );
            self.$parent.showhideemailpopup = false;
            self.resetEmailparams();
          }
        })
        .catch(function (error) {
          console.log(error);
          self.$parent.loadstatusmessage("Something went wrong", true);
          self.$parent.showhideemailpopup = false;
        });
    },

    onPrintPrescription() {
      this.printjobordered = false;
      var self = this;
      var thistimeoutsession = setTimeout((y) => {
        var content = document.getElementById(
          "modallistViewvdPrescriptionDetailsPrint"
        ).innerHTML;
        console.log("POPUP CONTENT>>>>", content);
        var mywindow = window.open(
          "",
          "PrintWindow",
          `width=${screen.width},height=${screen.height},top=0,left=0`
        );
        mywindow.document.write(
          "<html><head><title></title><style>.page-header .clinic-logo-hold{top: 5px !important;position:absolute;} .prescription-text{white-space:pre-line}p{margin-top:0;margin-bottom:0!important}.page-header,.page-header-space{height:180px}.page-header-space{margin-top:10px}.page-header-nospace{height:10px}.page-footer,.page-footer-space,.page-footer-nospace{height:100px}.page-footer{position:fixed;bottom: 5px;height: 100px;width:100%;border-top:1px solid rgb(212, 213, 215)}.page-header{position:fixed;top:0mm;height: 140px;width:100%;border-bottom:1px solid #000;}@page{size:A4;margin:0.50in;}@media print{thead{display:table-header-group}tfoot{display:table-footer-group}button{display:none}body{margin:0}dl{width:100%; overflow:hidden;} dt{width:170px; float:left;} dd{padding-left:170px;}}</style></head><body>"
        );
        mywindow.document.write(content);
        mywindow.document.write("</body></html>");
        mywindow.focus();
        mywindow.print();
        mywindow.close();
        self.printjobordered = true;
        clearTimeout(thistimeoutsession);
      }, 2000);
    },


    getUrlFromS3Bucket(bucketnameandkey) {
      var self = this;
      var suburl = "/S3Proxy";
      rest_service
        .downloadFromS3Bucket(suburl, this.tenantId, bucketnameandkey)
        .then(function (response) {
          if (response != null && response.data != null) {
            self.getdownloadfileUrl = response.data.result;
            var url_string = response.data.result;
            var url = new URL(url_string);
            var timestamp = url.searchParams.get("Expires");
            timestamp = Math.floor(timestamp * 1000);
            var ExpiryDateTime = new Date(timestamp);
            localStorage.setItem("SignatureExpiryDate", ExpiryDateTime);
            localStorage.setItem("SignatureUrl", self.getdownloadfileUrl);
          } else {
            return null;
          }
        })
        .catch(function (error) {
          return error;
        })
        .finally(() => {
          this.isrefreshpre = false;
        });
    },
    getstaffbyid(id) {
      var self = this;
      var suburl = "/staff";
      rest_service
        .getbyid(suburl, id, this.prescriptionobj.tenant_id, "get?id=" + id)
        .then(function (response) {
          if (response != null && response.data != null) {
            self.prescriptionobj.staffDetails = response.data.result;
            self.setCategory();
          } else {
            return null;
          }
        })
        .catch(function (error) {
          return error;
        });
    },
    getpatientdetails: function (patientid) {
      var currenttenant = localStorage.getItem("tenantid");
      var self = this;
      rest_service
        .getPatientInfo("/patient", this.prescriptionobj.tenant_id, patientid)
        .then((respo) => {
          if (respo.data && respo.data.result) {
            respo.data.result = JSON.parse(respo.data.result);
            if (respo.data.result.Date_of_birth) {
              self.ageCalculated = commonhelper.getAge(
                respo.data.result.Date_of_birth
              );
            } else if (respo.data.result.age) {
              self.ageCalculated = respo.data.result.age + " yrs";
            } else {
              self.ageCalculated = "N/A";
            }

            if (respo.data.result.tenant_map) {
              respo.data.result.tenant_map.forEach((element) => {
                if (element.tenant_id == currenttenant) {
                  self.prescriptionobj.patientdetails.patient_RegId =
                    element.patient_RegId;
                }
              });
            }

            // self.emaillist.push(self.prescriptionobj.patientdetails.email.toLowerCase());
          }
        })
        .catch(function (error) {
          return error;
        });
    },
    getSignature: function () {
      this.foldername =
        this.tenantId +
        this.$store.state.helper.patient_s3upload_Folders
          .scanReportDownloadPath +
        item;
    },
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    getQRCode() {
      rest_service.getQRCodeData();
      return this.$store.state.helper.qrcodeimagestr;
    },
    setCategory() {
      var self = this;
      if (
        self.prescriptionobj.staffDetails &&
        self.prescriptionobj.staffDetails.specialization
      ) {
        self.prescriptionobj.staffDetails.category =
          self.prescriptionobj.staffDetails.specialization;
      }
    },
    getPrescriptionStaticContent(staffId) {
      if (staffId) {
        rest_service.getPrescriptionStaticContent(staffId).then((respo) => {
          this.prescriptionFooterNote1 = respo;
        });
      }
    },
  },
};
</script>
<style scoped>
#modallistViewvdPrescriptionDetailsPrint table tbody td {
  border-right: 0 !important;
}

#modallistViewvdPrescriptionDetailsPrint table thead tr {
  background: #fff;
  border: 0 !important;
}

div#prescriptionFooterNote1 table {
  width: 100%;
}

.prescriptionFooterNotehold table tbody {
  border: none;
}

.page-header {
  position: static;
  width: 100%;
  height: auto;
}

.page-header .clinic-logo-hold {
  top: 23px !important;
  left: 20px;
}

.page-header-space {
  height: auto;
}

table.listview-table {
  font-family: arial, sans-serif;
  font-size: 14px;
  border-collapse: collapse;
  width: 100%;
}

table.listview-table th {
  border-top: 1px solid #666666;
  border-bottom: 1px solid #666666;
  text-align: left;
  padding: 3px 15px;
}

table.listview-table td {
  border: 0;
  text-align: left;
  padding: 5px;
}

table.listview-table tr:nth-child(even) {
  background-color: #fafafa;
}

.close-sec-hold {
  right: -45px !important;
  top: -50px;
}
</style>
<style scoped>
.drag-main-block {
  margin: 10px 0 10px;
}

.drag-block .top {
  display: flex;
  align-items: flex-start;
  grid-gap: 15px;
}
.prescription-text {
  white-space: pre-line;  
}
p {
    margin-top: 0;
   margin-bottom: 0 !important; 
}
</style>